import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';

export const OEToxnetzTargetType = {
    organs:         'organs',
    nervousSystem:  'nervousSystem',
    skeleton:       'skeleton',
    formulae:       'formulae'
};

OEToxnetzTargetType.all = [
    OEToxnetzTargetType.organs,
    OEToxnetzTargetType.nervousSystem,
    OEToxnetzTargetType.skeleton,
    OEToxnetzTargetType.formulae
];

export const OEToxnetzStartSelectionContent = {
    [OEToxnetzTargetType.organs]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.toxnetzTorso,
                        OETargetMenuDefs.humanLiverMicro,
                        OETargetMenuDefs.humanLiverSinusoid,
                        OETargetMenuDefs.humanCellEpithelium,
                        OETargetMenuDefs.humanLiverEnzyme,
                        OETargetMenuDefs.humanLiverEnzyme2
                    ]
                }
            ]
        }
    ],
    [OEToxnetzTargetType.nervousSystem]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanBrainNeuron,
                        OETargetMenuDefs.humanBrainSynapse,
                        OETargetMenuDefs.humanBrainACh,
                        OETargetMenuDefs.humanBrainMembrane,
                        OETargetMenuDefs.humanBrainPotential,
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanEyeRetina,
                        OETargetMenuDefs.humanEyeCornea,
                        OETargetMenuDefs.sensorySystems,
                        OETargetMenuDefs.humanEarMacro,
                        OETargetMenuDefs.humanEarInner,
                        OETargetMenuDefs.humanSkinEpidermis,
                        OETargetMenuDefs.humanSkin2
                    ]
                }
            ]
        }
    ],
    [OEToxnetzTargetType.skeleton]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanHand
                    ]
                }
            ]
        }
    ],
    [OEToxnetzTargetType.formulae]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.toxnetzFormelsammlung
                    ]
                }
            ]
        }
    ],

    [OEToxnetzTargetType.organs + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.toxnetzTorso,
                        OETargetMenuDefs.humanLiverMicro,
                        OETargetMenuDefs.humanLiverSinusoid,
                        OETargetMenuDefs.humanCellEpithelium,
                        OETargetMenuDefs.humanLiverEnzyme,
                        OETargetMenuDefs.humanLiverEnzyme2
                    ]
                }
            ]
        }
    ],
    [OEToxnetzTargetType.nervousSystem + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanBrainNeuron,
                        OETargetMenuDefs.humanBrainSynapse,
                        OETargetMenuDefs.humanBrainACh,
                        OETargetMenuDefs.humanBrainMembrane,
                        OETargetMenuDefs.humanBrainPotential,
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanEyeRetina,
                        OETargetMenuDefs.humanEyeCornea,
                        OETargetMenuDefs.sensorySystems,
                        OETargetMenuDefs.humanEarMacro
                    ]
                }
            ]
        }
    ],
    [OEToxnetzTargetType.skeleton + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanHand
                    ]
                }
            ]
        }
    ],
    [OEToxnetzTargetType.formulae + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.toxnetzFormelsammlung
                    ]
                }
            ]
        }
    ],

    [OEToxnetzTargetType.organs + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.toxnetzTorso,
                        OETargetMenuDefs.humanLiverMicro,
                        OETargetMenuDefs.humanLiverSinusoid,
                        OETargetMenuDefs.humanCellEpithelium,
                        OETargetMenuDefs.humanLiverEnzyme,
                        OETargetMenuDefs.humanLiverEnzyme2
                    ]
                }
            ]
        }
    ],
    [OEToxnetzTargetType.nervousSystem + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanBrainNeuron,
                        OETargetMenuDefs.humanBrainSynapse,
                        OETargetMenuDefs.humanBrainACh,
                        OETargetMenuDefs.humanBrainMembrane,
                        OETargetMenuDefs.humanBrainPotential,
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanEyeRetina,
                        OETargetMenuDefs.humanEyeCornea,
                        OETargetMenuDefs.sensorySystems,
                        OETargetMenuDefs.humanEarMacro
                    ]
                }
            ]
        }
    ],
    [OEToxnetzTargetType.skeleton + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanHand
                    ]
                }
            ]
        }
    ],
    [OEToxnetzTargetType.formulae + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.toxnetzFormelsammlung
                    ]
                }
            ]
        }
    ]
};

OEToxnetzStartSelectionContent.modules = [
    {id: OEToxnetzTargetType.organs, icon: OEIconCodes.toxnetz.organsTarget, categories: OEToxnetzStartSelectionContent[OEToxnetzTargetType.organs]},
    {id: OEToxnetzTargetType.nervousSystem, icon: OEIconCodes.toxnetz.nervousSystemTarget, categories: OEToxnetzStartSelectionContent[OEToxnetzTargetType.nervousSystem]},
    {id: OEToxnetzTargetType.skeleton, icon: OEIconCodes.toxnetz.skeletonTarget, categories: OEToxnetzStartSelectionContent[OEToxnetzTargetType.skeleton]},
    {id: OEToxnetzTargetType.formulae, icon: OEIconCodes.toxnetz.formulaeTarget, categories: OEToxnetzStartSelectionContent[OEToxnetzTargetType.formulae]}
];

OEToxnetzStartSelectionContent.modulesBeta = [
    {id: OEToxnetzTargetType.organs, icon: OEIconCodes.toxnetz.organsTarget, categories: OEToxnetzStartSelectionContent[OEToxnetzTargetType.organs + OEAlphaBetaProdTypes.beta]},
    {id: OEToxnetzTargetType.nervousSystem, icon: OEIconCodes.toxnetz.nervousSystemTarget, categories: OEToxnetzStartSelectionContent[OEToxnetzTargetType.nervousSystem + OEAlphaBetaProdTypes.beta]},
    {id: OEToxnetzTargetType.skeleton, icon: OEIconCodes.toxnetz.skeletonTarget, categories: OEToxnetzStartSelectionContent[OEToxnetzTargetType.skeleton + OEAlphaBetaProdTypes.beta]},
    {id: OEToxnetzTargetType.formulae, icon: OEIconCodes.toxnetz.formulaeTarget, categories: OEToxnetzStartSelectionContent[OEToxnetzTargetType.formulae + OEAlphaBetaProdTypes.beta]}
];

OEToxnetzStartSelectionContent.modulesProduction = [
    {id: OEToxnetzTargetType.organs, icon: OEIconCodes.toxnetz.organsTarget, categories: OEToxnetzStartSelectionContent[OEToxnetzTargetType.organs + OEAlphaBetaProdTypes.prod]},
    {id: OEToxnetzTargetType.nervousSystem, icon: OEIconCodes.toxnetz.nervousSystemTarget, categories: OEToxnetzStartSelectionContent[OEToxnetzTargetType.nervousSystem + OEAlphaBetaProdTypes.prod]},
    {id: OEToxnetzTargetType.skeleton, icon: OEIconCodes.toxnetz.skeletonTarget, categories: OEToxnetzStartSelectionContent[OEToxnetzTargetType.skeleton + OEAlphaBetaProdTypes.prod]},
    {id: OEToxnetzTargetType.formulae, icon: OEIconCodes.toxnetz.formulaeTarget, categories: OEToxnetzStartSelectionContent[OEToxnetzTargetType.formulae + OEAlphaBetaProdTypes.prod]}
];